var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-warpper"},[_c('div',{staticClass:"page-header__content",on:{"click":_vm.back}},[_vm._m(0),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("@/assets/img/back.svg"),"alt":""}})])
}]

export { render, staticRenderFns }